
import React from 'react';
import { BookOpen, TrendingUp, Compass } from 'lucide-react';
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

interface QuickFiltersProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
}

const QuickFilters: React.FC<QuickFiltersProps> = ({ activeTab, setActiveTab }) => {
  return (
    <div className="mb-8">
      <ToggleGroup 
        type="single" 
        value={activeTab} 
        onValueChange={(value) => value && setActiveTab(value)}
      >
        <ToggleGroupItem value="following" aria-label="Following">
          <BookOpen className="h-4 w-4 mr-2" />
          Following
        </ToggleGroupItem>
        <ToggleGroupItem value="trending" aria-label="Trending">
          <TrendingUp className="h-4 w-4 mr-2" />
          Trending
        </ToggleGroupItem>
        <ToggleGroupItem value="discover" aria-label="Discover">
          <Compass className="h-4 w-4 mr-2" />
          Discover
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};

export default QuickFilters;
